import { render, staticRenderFns } from "./trainingCourse.vue?vue&type=template&id=6c5e9fed&scoped=true"
import script from "./trainingCourse.vue?vue&type=script&lang=js"
export * from "./trainingCourse.vue?vue&type=script&lang=js"
import style0 from "./trainingCourse.vue?vue&type=style&index=0&id=6c5e9fed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e9fed",
  null
  
)

export default component.exports